export const requestSubmitPolyfill = () => {
  const validateSubmitter = (submitter: HTMLInputElement, form: HTMLFormElement) => {
    if (!(submitter instanceof HTMLElement)) {
      throw new TypeError('parameter 1 is not of type \'HTMLElement\'')
    }
    if (submitter.type !== 'submit') {
      throw new TypeError('The specified element is not a submit button')
    }
    if (submitter.form !== form) {
      throw new DOMException('The specified element is not owned by this form element', 'NotFoundError')
    }
  }

  if (typeof HTMLFormElement.prototype.requestSubmit !== 'function') {
    HTMLFormElement.prototype.requestSubmit = function(submitter?: HTMLInputElement) {
      if (submitter) {
        validateSubmitter(submitter, this)
        submitter.click()
      } else {
        submitter = document.createElement('input')
        submitter.type = 'submit'
        submitter.hidden = true

        this.appendChild(submitter)
        submitter.click()
        this.removeChild(submitter)
      }
    }
  }
}
